import React from 'react'

export const StatTableHeader = ({totalTable}) => {

  const cellColor = totalTable ? '#D5E6FF' : '#E1CCE7'

  return (
    <div className={`grid sticky top-[6rem] grid-cols-[72rem_1fr_1fr] text-center font-bold text-Regular(14_16) gap-[1px]`}>
      <div className={`py-[2.2rem]`} style={{backgroundColor: cellColor}}>Виды работ</div>
      <div className={`py-[2.2rem] bg-[#FFFFFF]`}>Отпечатков, ед.</div>
      <div className={`py-[2.2rem] bg-[#FFFFFF]`}>Тираж, ед.</div>
    </div>
  )
}